import React from "react";

const GuestSetting = ({ guestData, setGuestData, handleGuestSubmit }) => {
  const handleChange = (e) => {
    const value = e.target.value;

    // Allow only digits (including zero), block negatives and letters
    if (/^\d*$/.test(value)) {
      setGuestData({ ...guestData, totalminimum: value });
    }
  };

  const handleSave = () => {
    const minGuest = parseInt(guestData.totalminimum, 10);

    if (isNaN(minGuest) || minGuest < 0) {
      return alert("Please enter a valid guest count (0 or more)");
    }

    handleGuestSubmit();
  };

  return (
    <div className="gst-setting-container">
      <label className="gst-setting-label">Minimum Guest</label>
      <div className="gst-setting-inline">
        <input
          type="number"
          min="0"
          className="gst-setting-input"
          value={guestData?.totalminimum || ""}
          onChange={handleChange}
          placeholder="Enter Minimum Guest"
        />
        <button className="gst-setting-save-btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default GuestSetting;
